/*
 * MentionsLegales — GSF Arbitral AI Vitrine
 * Design: Marine #0D1B2A, Or métallique #C9A84C, Cormorant Garamond + Inter
 * Contenu identique aux mentions légales de eji2.org, adapté à GSF Arbitral AI
 */
import { Link } from "wouter";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const MARINE = "oklch(0.175 0.038 243)";
const GOLD = "oklch(0.695 0.105 68)";

export default function MentionsLegales() {
  return (
    <div className="min-h-screen" style={{ background: "oklch(1 0 0)" }}>
      <Navbar />

      {/* Hero de page */}
      <section
        className="pt-28 pb-16"
        style={{ background: MARINE }}
      >
        <div className="container">
          <div className="gsf-badge mb-4">Informations Légales</div>
          <h1
            className="font-bold leading-tight"
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: "clamp(2rem, 5vw, 3.5rem)",
              color: "oklch(1 0 0)",
              lineHeight: 1.1,
            }}
          >
            Mentions Légales &amp; Conformité
          </h1>
          <p className="mt-3 text-sm" style={{ color: "oklch(0.70 0.01 243)" }}>
            Dernière mise à jour : 2 avril 2026
          </p>
        </div>
      </section>

      <div className="gsf-gold-line" />

      {/* Contenu */}
      <section className="py-16">
        <div className="container max-w-3xl mx-auto">

          <Link
            href="/"
            className="inline-flex items-center gap-2 text-sm mb-10 no-underline transition-colors"
            style={{ color: GOLD }}
          >
            <ArrowLeft size={14} />
            Retour à l'accueil
          </Link>

          <p className="text-base leading-relaxed mb-10" style={{ color: "oklch(0.45 0.01 243)" }}>
            Conformément aux dispositions légales applicables, les présentes mentions légales ont pour objet d'informer les utilisateurs du site sur l'identité de l'éditeur, les conditions d'hébergement, les règles de propriété intellectuelle et les modalités de contact.
          </p>

          {[
            {
              num: "1",
              title: "Éditeur du site",
              content: (
                <>
                  <p className="text-sm leading-relaxed mb-2" style={{ color: "oklch(0.45 0.01 243)" }}>
                    Le présent site est édité par :
                  </p>
                  <div
                    className="p-5 rounded-sm text-sm leading-relaxed"
                    style={{ background: "oklch(0.97 0.005 243)", border: "1px solid oklch(0.90 0.005 243)" }}
                  >
                    <p className="font-semibold mb-1" style={{ color: MARINE }}>ÉTHIQUE JURIDIQUE 2.0. INTERNATIONALE (EJI 2.0) W941020107</p>
                    <p style={{ color: "oklch(0.45 0.01 243)" }}>Siège social : 11 quai Anatole France, 75007 Paris. Tel. + 33 1 48 98 02 07</p>
                    <p style={{ color: "oklch(0.45 0.01 243)" }}>
                      E-mail. :{" "}
                      <a href="mailto:contact@eji2.org" style={{ color: GOLD }}>
                        contact@eji2.org
                      </a>
                    </p>
                  </div>
                </>
              ),
            },
            {
              num: "2",
              title: "Directeur de la publication",
              content: (
                <p className="text-sm leading-relaxed" style={{ color: "oklch(0.45 0.01 243)" }}>
                  <strong style={{ color: MARINE }}>Monsieur Gilles Feliho</strong>
                  <br />
                  En qualité de représentant de ÉTHIQUE JURIDIQUE 2.0. INTERNATIONALE (EJI 2.0) W941020107.
                </p>
              ),
            },
            {
              num: "3",
              title: "Hébergement",
              content: (
                <>
                  <p className="text-sm leading-relaxed mb-3" style={{ color: "oklch(0.45 0.01 243)" }}>
                    Ce site est hébergé par :
                  </p>
                  <div
                    className="p-5 rounded-sm text-sm leading-relaxed"
                    style={{ background: "oklch(0.97 0.005 243)", border: "1px solid oklch(0.90 0.005 243)" }}
                  >
                    <p className="font-semibold mb-1" style={{ color: MARINE }}>Vercel Inc.</p>
                    <p style={{ color: "oklch(0.45 0.01 243)" }}>340 Pine Street, Suite 701, San Francisco, CA 94104, États-Unis</p>
                    <p style={{ color: "oklch(0.45 0.01 243)" }}>
                      Site web :{" "}
                      <a href="https://www.vercel.com" target="_blank" rel="noopener noreferrer" style={{ color: GOLD }}>
                        www.vercel.com
                      </a>
                    </p>
                  </div>
                  <p className="text-sm leading-relaxed mt-3" style={{ color: "oklch(0.45 0.01 243)" }}>
                    Le code source et les contenus du site peuvent être administrés via des outils tiers de gestion de version et de gestion éditoriale, sans que ces services constituent nécessairement l'hébergeur public du site.
                  </p>
                </>
              ),
            },
            {
              num: "4",
              title: "Propriété intellectuelle",
              content: (
                <>
                  <p className="text-sm leading-relaxed mb-3" style={{ color: "oklch(0.45 0.01 243)" }}>
                    L'ensemble des contenus présents sur ce site, notamment les textes, analyses, visuels, images, graphismes, logos, icônes, documents, téléchargements, structure éditoriale et éléments de présentation, est protégé par les règles applicables en matière de propriété intellectuelle.
                  </p>
                  <p className="text-sm leading-relaxed mb-3" style={{ color: "oklch(0.45 0.01 243)" }}>
                    Sauf mention contraire, ces contenus sont la propriété exclusive de ÉTHIQUE JURIDIQUE 2.0. INTERNATIONALE (EJI 2.0) W941020107 ou sont utilisés avec l'autorisation de leurs titulaires respectifs.
                  </p>
                  <p className="text-sm leading-relaxed" style={{ color: "oklch(0.45 0.01 243)" }}>
                    Toute reproduction, représentation, diffusion, adaptation, extraction ou exploitation, totale ou partielle, sans autorisation écrite préalable, est interdite, sauf dans les cas prévus par la réglementation applicable.
                  </p>
                </>
              ),
            },
            {
              num: "5",
              title: "Responsabilité",
              content: (
                <>
                  <p className="text-sm leading-relaxed mb-3" style={{ color: "oklch(0.45 0.01 243)" }}>
                    ÉTHIQUE JURIDIQUE 2.0. INTERNATIONALE (EJI 2.0) W941020107 s'efforce d'assurer au mieux l'exactitude et la mise à jour des informations diffusées sur le site. Toutefois, le cabinet ne saurait garantir l'absence totale d'erreurs, d'omissions ou d'indisponibilités temporaires.
                  </p>
                  <p className="text-sm leading-relaxed mb-3" style={{ color: "oklch(0.45 0.01 243)" }}>
                    Les informations publiées sur le site sont fournies à titre informatif et ne sauraient être interprétées comme constituant, à elles seules, un conseil juridique, réglementaire ou stratégique individualisé.
                  </p>
                  <p className="text-sm leading-relaxed" style={{ color: "oklch(0.45 0.01 243)" }}>
                    L'utilisateur demeure seul responsable de l'usage qu'il fait des informations accessibles sur le site.
                  </p>
                </>
              ),
            },
            {
              num: "6",
              title: "Données personnelles",
              content: (
                <p className="text-sm leading-relaxed" style={{ color: "oklch(0.45 0.01 243)" }}>
                  Les traitements de données personnelles mis en œuvre via le site sont encadrés par notre politique de confidentialité. Pour toute demande relative à vos données personnelles, écrivez à{" "}
                  <a href="mailto:contact@eji2.org" style={{ color: GOLD }}>contact@eji2.org</a>.
                </p>
              ),
            },
            {
              num: "7",
              title: "Cookies",
              content: (
                <p className="text-sm leading-relaxed" style={{ color: "oklch(0.45 0.01 243)" }}>
                  Le site peut utiliser des cookies ou traceurs strictement nécessaires à son fonctionnement technique, à la sécurité de la navigation ou, le cas échéant, à la mesure d'audience.
                </p>
              ),
            },
            {
              num: "8",
              title: "Liens externes",
              content: (
                <p className="text-sm leading-relaxed" style={{ color: "oklch(0.45 0.01 243)" }}>
                  Le site peut contenir des liens vers des sites, documents, plateformes ou ressources externes. ÉTHIQUE JURIDIQUE 2.0. INTERNATIONALE (EJI 2.0) W941020107 ne peut être tenu responsable du contenu, de la disponibilité, ni des politiques légales ou de confidentialité de ces sites tiers.
                </p>
              ),
            },
            {
              num: "9",
              title: "Contact",
              content: (
                <p className="text-sm leading-relaxed" style={{ color: "oklch(0.45 0.01 243)" }}>
                  Pour toute question relative au site, à son contenu, à ses publications ou à son fonctionnement, vous pouvez écrire à :{" "}
                  <a href="mailto:contact@eji2.org" style={{ color: GOLD }}>contact@eji2.org</a>
                  <br /><br />
                  Vous pouvez également utiliser le{" "}
                  <Link href="/#contact" style={{ color: GOLD }}>formulaire de contact</Link>.
                </p>
              ),
            },
            {
              num: "10",
              title: "Mise à jour",
              content: (
                <p className="text-sm leading-relaxed" style={{ color: "oklch(0.45 0.01 243)" }}>
                  Les présentes mentions légales peuvent être modifiées à tout moment afin de tenir compte des évolutions légales, réglementaires, techniques ou éditoriales.
                  <br /><br />
                  <strong style={{ color: MARINE }}>Dernière mise à jour :</strong> 2 avril 2026
                </p>
              ),
            },
            {
              num: "11",
              title: "Objet & qualification du système d'IA (haut risque)",
              content: (
                <p className="text-sm leading-relaxed" style={{ color: "oklch(0.45 0.01 243)" }}>
                  GSF Arbitral est une plateforme de gestion des procédures d'arbitrage
                  international intégrant des systèmes d'intelligence artificielle à titre
                  d'assistance. Conformément à l'article 6 § 1 et au point 8 de l'Annexe III
                  du Règlement (UE) 2024/1689 (« AI Act »), ces systèmes sont qualifiés d'IA
                  à <strong style={{ color: MARINE }}>haut risque</strong>.
                </p>
              ),
            },
            {
              num: "12",
              title: "Conformité IA — Règlement (UE) 2024/1689 (« AI Act »)",
              content: (
                <div
                  className="p-5 rounded-sm text-sm leading-relaxed space-y-3"
                  style={{ background: "oklch(0.97 0.005 243)", border: "1px solid oklch(0.90 0.005 243)", color: "oklch(0.45 0.01 243)" }}
                >
                  <p><strong style={{ color: MARINE }}>A. Transparence (art. 50).</strong> Les utilisateurs sont informés qu'ils interagissent avec un système d'IA et avec des résultats produits par celui-ci.</p>
                  <p><strong style={{ color: MARINE }}>B. Gestion des risques (art. 9).</strong> Système de gestion des risques itératif et continu sur l'ensemble du cycle de vie : identification et analyse des risques connus et prévisibles, évaluation des risques résiduels, mesures de mitigation proportionnées, réduction des risques significatifs à un niveau acceptable.</p>
                  <p><strong style={{ color: MARINE }}>C. Qualité des données (art. 10).</strong> Gouvernance rigoureuse des jeux de données d'entraînement, de validation et de test (pertinence, représentativité, exemption d'erreurs, complétude) ; mesures de détection, prévention et correction des biais.</p>
                  <p><strong style={{ color: MARINE }}>D. Surveillance humaine (art. 14).</strong> Surveillance effective par les arbitres et le secrétariat. Les décisions juridictionnelles — admission des moyens, appréciation des preuves, motivation et dispositif de la sentence — relèvent <em>exclusivement</em> de l'arbitre.</p>
                  <p><strong style={{ color: MARINE }}>E. Robustesse, précision & cybersécurité (art. 15).</strong> Niveau approprié de précision, de robustesse et de cybersécurité ; tests résilients (simulation d'erreurs, de défaillances et d'attaques — modèles adverses, empoisonnement des données).</p>
                  <p><strong style={{ color: MARINE }}>F. Documentation & journalisation (art. 13).</strong> Documentation technique et instructions d'utilisation conformes à l'Annexe IV ; journaux d'événements (logs) assurant la traçabilité (Annexe III, point 1).</p>
                  <p><strong style={{ color: MARINE }}>G. Évaluation de conformité & marquage CE (art. 43-49).</strong> Évaluation de conformité préalable à la mise sur le marché et marquage CE.</p>
                  <p><strong style={{ color: MARINE }}>H. Enregistrement (art. 71).</strong> Enregistrement des systèmes dans la base de données de l'UE prévue à l'article 71.</p>
                </div>
              ),
            },
            {
              num: "13",
              title: "Protection des données personnelles (RGPD — Règlement (UE) 2016/679)",
              content: (
                <ul className="text-sm leading-relaxed space-y-2 list-disc pl-5" style={{ color: "oklch(0.45 0.01 243)" }}>
                  <li><strong style={{ color: MARINE }}>Responsable du traitement :</strong> GSF Arbitral.</li>
                  <li>
                    <strong style={{ color: MARINE }}>Délégué à la protection des données (DPO) :</strong>{" "}
                    <a href="mailto:dpo@gsfarbitral.ai" style={{ color: GOLD }}>dpo@gsfarbitral.ai</a>.
                  </li>
                  <li><strong style={{ color: MARINE }}>Finalités & base légale :</strong> gestion et suivi des procédures d'arbitrage (exécution du contrat, art. 6 § 1 b ; respect des obligations légales, art. 6 § 1 c).</li>
                  <li><strong style={{ color: MARINE }}>Durée de conservation :</strong> durée de la procédure, puis archivage selon les délais de prescription applicables.</li>
                  <li><strong style={{ color: MARINE }}>Destinataires :</strong> arbitres, secrétariat du tribunal arbitral et, le cas échéant, prestataires techniques tenus à une obligation de confidentialité.</li>
                  <li><strong style={{ color: MARINE }}>Droits :</strong> accès, rectification, effacement, limitation, portabilité, opposition, directives post mortem — exercice par écrit auprès du DPO.</li>
                  <li>
                    <strong style={{ color: MARINE }}>Réclamation :</strong> droit d'introduire une réclamation auprès de la CNIL —{" "}
                    <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" style={{ color: GOLD }}>www.cnil.fr</a>.
                  </li>
                </ul>
              ),
            },
          ].map((section) => (
            <div
              key={section.num}
              className="mb-10 pb-10"
              style={{ borderBottom: "1px solid oklch(0.92 0.004 243)" }}
            >
              <h2
                className="text-2xl font-bold mb-5"
                style={{ fontFamily: "'Cormorant Garamond', serif", color: MARINE }}
              >
                {section.num}. {section.title}
              </h2>
              {section.content}
            </div>
          ))}

          <div className="mt-4 pt-6 flex flex-wrap gap-4 text-sm" style={{ borderTop: "1px solid oklch(0.92 0.004 243)" }}>
            <Link href="/" style={{ color: GOLD, textDecoration: "none" }}>
              ← Retour à l'accueil
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
